import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function PaymentsPage() {
  return (
    <SectionLayout title="Payments">
      {/* Payments content will go here */}
    </SectionLayout>
  );
} 